
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import { HeroSection } from "@/components/landing/HeroSection";
import { FeaturesSection } from "@/components/landing/FeaturesSection";
import { WorkflowSection } from "@/components/landing/WorkflowSection";
import { AnalyticsSection } from "@/components/landing/AnalyticsSection";
import { CTASection } from "@/components/landing/CTASection";
import { Footer } from "@/components/landing/Footer";
import { addSubscriber } from "@/lib/subscription";

const Landing = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast({
        title: "Invalid email",
        description: "Please enter a valid email address",
        variant: "destructive",
      });
      return;
    }

    setIsSubmitting(true);
    
    try {
      const { success, error } = await addSubscriber(email);
      
      if (success) {
        toast({
          title: "Thanks for subscribing!",
          description: "We'll keep you updated on Agent V",
        });
        setSubscribed(true);
      } else {
        throw new Error(error || "Failed to subscribe");
      }
    } catch (error: any) {
      toast({
        title: "Something went wrong",
        description: error.message || "Please try again later",
        variant: "destructive",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <HeroSection 
        email={email}
        setEmail={setEmail}
        handleSubscribe={handleSubscribe}
        isSubmitting={isSubmitting}
        subscribed={subscribed}
        handleLogin={handleLogin}
      />
      <FeaturesSection />
      <WorkflowSection />
      <AnalyticsSection />
      <CTASection 
        email={email}
        setEmail={setEmail}
        handleSubscribe={handleSubscribe}
        isSubmitting={isSubmitting}
        subscribed={subscribed}
      />
      <Footer />
    </div>
  );
};

export default Landing;
